<template>
  <div class="card-container">
    <common-el-form
      :model="model"
      :rules="rules"
      :submitData="submitData"
      @success="onSuccess"
      ref="commonElForm"
      :showButton="false"
      :inline="false"
      :SubmitButton="true"
      :noneButton="!isHaved"
      :needBeforeSubmit="needBeforeSubmit"
      submit-btn-text="保存"
      failTitle="提交失败"
      loadingText="提交中..."
      :hideRequiredAsterisk="true"
      :submitService="submitService"
      @beforeSubmit="beforeSubmit"
      class="common-margin"
    >
      <el-form-item label="分享内容" prop="titleName">
        <el-input
          type="textarea"
          maxlength="200"
          placeholder="请输入分享内容..."
          show-word-limit
          resize="none"
          rows="4"
          v-model="model.titleName"
          style="width: 300px"
          :disabled="isHaved"
        ></el-input>
      </el-form-item>
      <el-form-item label="类型描述" prop="type">
        <el-input
          type="text"
          style="width: 300px"
          v-model="model.type"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <div v-if="shareId">
        <el-alert
          title="请上传尺寸为1080 * 1700 px ，且不超过200kb图片文件， 最多可上传三张"
          :closable="false"
          type="warning"
          show-icon
          style="margin-bottom: 20px"
        ></el-alert>
        <el-form-item label="分享图片">
          <el-upload
            ref="picture1"
            class="avatar-uploader"
            :action="uploadUrl + '8880/tatTatSourceMaterial/uploadfile'"
            :data="commonParams"
            :disabled="isHaved"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
            :on-error="handleAvatarError"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload1"
          >
            <img v-if="picture1" :src="picture1" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div class="btn-bg" @click.stop="delShare(1)">
              <i class="el-icon-delete avatar-uploader-icon"></i>
            </div>
          </el-upload>
          <el-upload
            ref="picture2"
            class="avatar-uploader"
            :action="uploadUrl + '8880/tatTatSourceMaterial/uploadfile'"
            :data="commonParams"
            :disabled="isHaved"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
            :on-error="handleAvatarError"
            :before-upload="beforeAvatarUpload2"
          >
            <img v-if="picture2" :src="picture2" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div class="btn-bg" @click.stop="delShare(2)">
              <i class="el-icon-delete avatar-uploader-icon"></i>
            </div>
          </el-upload>
          <el-upload
            ref="picture3"
            class="avatar-uploader"
            :action="uploadUrl + '8880/tatTatSourceMaterial/uploadfile'"
            :data="commonParams"
            :disabled="isHaved"
            :show-file-list="false"
            :on-success="handleAvatarSuccess3"
            :on-error="handleAvatarError"
            :before-upload="beforeAvatarUpload3"
          >
            <img v-if="picture3" :src="picture3" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div class="btn-bg" @click.stop="delShare(3)">
              <i class="el-icon-delete avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </el-form-item>
      </div>
    </common-el-form>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import APPService from "service/APPService";
import Server from "common/conf/Server";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import StorageService from "store/interfaces";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MultiShareUpdate",
  data() {
    return {
      model: {
        titleName: "",
        type: "",
      },
      rules: {
        titleName: [
          {
            required: true,
            message: "请输入分享内容",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      isHaved: false,
      needBeforeSubmit: false,
      stepActive: 1,
      pictureNumber: 1,
      detail: {},
      shareId: "",
      picture1: "",
      picture2: "",
      picture3: "",
      uploadUrl: Server[process.env.NODE_ENV],
      uploadParams1: {},
      uploadParams2: {},
      uploadParams3: {},
    };
  },
  components: {
    CommonElForm,
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        type: this.model.type,
        titleName: this.model.titleName,
      };
      if (this.shareId) {
        params.id = this.shareId;
        for (let i = 1; i < 4; i++) {
          if (this["picture" + i] == "") {
            params["picture" + i] = this["picture" + i];
          }
        }
      }
      return params;
    },
    submitService() {
      return this.shareId
        ? APPService.tatTatSourceMaterialEdit
        : APPService.tatTatSourceMaterialAdd;
    },
    commonParams() {
      const params = {
        id: this.shareId,
        serverType: this.serverType,
        type: this.model.type,
        pictureNumber: this.pictureNumber,
        tatId: this.tatId,
        userId: this.userId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      console.log(params);
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.isHaved = JSON.parse(this.$route.params.isHaved);
    if (this.$route.params.item) {
      this.model = JSON.parse(this.$route.params.item);
      this.shareId = this.model.id;
      if (this.shareId) {
        for (let i = 1; i < 4; i++) {
          if (this.model["picture" + i]) {
            this["picture" + i] = this.model["picture" + i];
          }
        }
      }
    }
  },
  methods: {
    goBack() {
      this.isReloadPage(true);
      this.showSuccess("操作成功");
      this.$router.back();
    },
    beforeSubmit() {
      if (!this.picture1 && !this.picture2 && !this.picture3) {
        this.showWarming("请至少上传一张分享图片");
        return;
      }
      this.needBeforeSubmit = false;
      this.$nextTick(() => {
        this.goBack();
      });
    },
    onSuccess(res) {
      if (!this.shareId) {
        this.shareId = res.contents;
      }

      this.needBeforeSubmit = true;
      if (this.model.id) {
        this.goBack();
      }
      if (typeof res.contents == "object") {
        this.goBack();
      }
    },
    handleAvatarSuccess1(res, file) {
      if (res.respCode == "0000") {
        this.picture1 = URL.createObjectURL(file.raw);
      } else {
        this.showError(res.respMsg);
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleAvatarSuccess2(res, file) {
      if (res.respCode == "0000") {
        this.picture2 = URL.createObjectURL(file.raw);
      } else {
        this.showError(res.respMsg);
      }
    },
    handleAvatarSuccess3(res, file) {
      if (res.respCode == "0000") {
        this.picture3 = URL.createObjectURL(file.raw);
      } else {
        this.showError(res.respMsg);
      }
    },
    handleAvatarError(err, file, fileList) {
      this.showError("上传失败");
    },
    beforeAvatarUpload1(file) {
      const _this = this;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";

      const isLt2M = file.size / 1024 / 1024 / 1024 < 2;

      const isSize = new Promise(function (resolve, reject) {
        let width = 1080;
        let height = 1700;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          _this.$message.error("上传图片文件尺寸需为1080 * 1700px!");
          return Promise.reject();
        }
      );

      if (!isJPG && !isPNG) {
        _this.$message.error("上传图片文件只能是 JPG 或 PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        _this.$message.error("上传图片文件大小不能超过 2MB!");
        return false;
      }

      this.pictureNumber = 1;
      return (isJPG || isPNG) && isLt2M && isSize;
    },
    beforeAvatarUpload2(file) {
      const _this = this;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";

      const isLt2M = file.size / 1024 / 1024 < 2;

      const isSize = new Promise(function (resolve, reject) {
        let width = 1080;
        let height = 1700;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          _this.$message.error("上传图片文件尺寸需为1080 * 1700px!");
          return Promise.reject();
        }
      );

      if (!isJPG && !isPNG) {
        _this.$message.error("上传图片文件只能是 JPG 或 PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        _this.$message.error("上传图片文件大小不能超过 2MB!");
        return false;
      }

      this.pictureNumber = 2;
      return (isJPG || isPNG) && isLt2M && isSize;
    },
    beforeAvatarUpload3(file) {
      const _this = this;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";

      const isLt2M = file.size / 1024 / 1024 < 2;

      const isSize = new Promise(function (resolve, reject) {
        let width = 1080;
        let height = 1700;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          _this.$message.error("上传图片文件尺寸需为1080 * 1700px!");
          return Promise.reject();
        }
      );

      if (!isJPG && !isPNG) {
        _this.$message.error("上传图片文件只能是 JPG 或 PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        _this.$message.error("上传图片文件大小不能超过 2MB!");
        return false;
      }

      this.pictureNumber = 3;
      return (isJPG || isPNG) && isLt2M && isSize;
    },
    delShare(index) {
      this["picture" + index] = "";
    },
    ...mapActions({
      isReloadPage: StorageService.Reload.page,
    }),
  },
};
</script>

<style scoped>
.avatar-uploader {
  display: inline-block;
  vertical-align: top;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 230px;
  height: 400px;
  line-height: 400px;
  text-align: center;
}

.avatar {
  width: 230px;
  height: 400px;
  display: block;
}

.btn-bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  opacity: 0;
  transform: translateY(100%);
  transition: all 0.5s linear;
}

.avatar:hover + .btn-bg {
  opacity: 1;
  transform: translateY(0%);
}

.el-button--text {
  color: #f5f5f5;
}

.el-button--text:hover {
  color: #079ade;
}

.el-alert-box {
  margin: 30px 0px 0 30px;
}

.el-alert--warning.is-light {
  padding: 15px 16px;
}

.el-icon-delete {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/MultiShareUpdate.vue